import React from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { Button, Modal, Row, Col } from 'antd';
import cx from 'classnames';

import { getFullName } from 'utils/personUtils';
import WorkerGeneralInfo from '../WorkerGeneralInfo';
import BaseAlert from 'components/wrappers/BaseAlert';
import { mergeWorker } from 'redux/reducers/workerSlice';
import { WorkerDetailViewModel } from 'api/adminApiClient';
import { ApiErrorMessage } from 'constants/ErrorMessages';
import BaseCollapse from 'components/wrappers/BaseCollapse';
import { useAppDispatch } from 'hooks/useAppDispatch';

import styles from './PotentialDuplicateWorker.module.less';

const { Panel } = BaseCollapse;

type Props = {
  workerId: string;
  isMergeDisabled: boolean;
  duplicateWorker: WorkerDetailViewModel;
  disableButtons: React.Dispatch<React.SetStateAction<boolean>>;
};

export default function PotentialDuplicateWorker(props: Props) {
  const {
    workerId,
    duplicateWorker,
    isMergeDisabled,
    disableButtons,
    ...rest
  } = props;
  const navigate = useNavigate();
  const dispatch = useAppDispatch();
  const { workerInfo } = duplicateWorker;

  const onMergeWorkers = async () => {
    disableButtons(true);

    const result = await dispatch(
      mergeWorker({ workerId, originalWorkerId: duplicateWorker.id as string }),
    );

    disableButtons(false);

    if (mergeWorker.fulfilled.match(result)) {
      navigate(`/worker/${duplicateWorker.workerKey}`, { replace: true });
      BaseAlert.success('Workers successfully merged.');
    } else {
      BaseAlert.error(result.error.message || ApiErrorMessage);
    }
  };

  const handleMerge = () => {
    return Modal.confirm({
      title:
        'Are you sure? After the merge, the current worker record will be replaced with the selected one.',
      icon: <span className="icon icon-attention-filled" />,
      onOk() {
        onMergeWorkers();
      },
      onCancel() {},
    });
  };

  return (
    <Panel
      className={styles.mergeBox}
      {...rest}
      key={`duplicate-worker-${duplicateWorker.id}`}
      header={
        <Row
          gutter={[10, 10]}
          className={styles.mergeRow}
          onClick={(e) => e.stopPropagation()}
        >
          <Col xs={16} md={18}>
            <div className="title">Worker name:</div>
            <Link to={`/worker/${duplicateWorker.workerKey}`}>
              {getFullName(workerInfo?.firstName, workerInfo?.lastName)}
            </Link>
          </Col>
          <Col xs={8} md={6} className={cx('d-flex', styles.mergeBtn)}>
            <Button
              onClick={handleMerge}
              loading={isMergeDisabled}
              size="large"
            >
              Merge
            </Button>
          </Col>
        </Row>
      }
    >
      <Row gutter={[4, 4]} className="titled-sheet">
        <WorkerGeneralInfo worker={duplicateWorker} />
      </Row>
    </Panel>
  );
}
